import { render, staticRenderFns } from "./PricingPopup.vue?vue&type=template&id=4345f4cb&scoped=true"
import script from "./PricingPopup.vue?vue&type=script&lang=js"
export * from "./PricingPopup.vue?vue&type=script&lang=js"
import style0 from "./PricingPopup.vue?vue&type=style&index=0&id=4345f4cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4345f4cb",
  null
  
)

export default component.exports